import { Injectable, EventEmitter, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormUtlityCommanFunction } from "@mmortgage/dynamic-form";
import { localTempObject } from "@mmortgage/dynamic-form";
import { IformGroupObject } from "@mmortgage/dynamic-form";
import { Borrower } from "@mmortgage/dynamic-form";

@Injectable()
export class FormElementScriptFunctions implements OnInit {

    private eleScriformUliFunObj: FormUtlityCommanFunction;
    private eleScritempLocalObj: localTempObject;
    private elemScriFuncEmit: EventEmitter<string> = new EventEmitter<string>();
    private parentObj: any;
    private EnumData: any;
    private lang: any;
    private occupation_data = { 'occupationDetails': [{ 'category': '20', 'occupation': [{ 'occupationCode': '1001', 'subTypes': [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21] }, { 'occupationCode': '1002', 'subTypes': [22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34] }] }, { 'category': '21', 'occupation': [{ 'occupationCode': '1003', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1004', 'subTypes': [] }, { 'occupationCode': '1005', 'subTypes': [] }, { 'occupationCode': '1006', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1007', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1008', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1009', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1010', 'subTypes': [] }, { 'occupationCode': '1011', 'subTypes': [] }, { 'occupationCode': '1012', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1013', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1014', 'subTypes': [] }, { 'occupationCode': '1015', 'subTypes': [] }, { 'occupationCode': '1016', 'subTypes': [] }, { 'occupationCode': '1017', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1018', 'subTypes': [] }, { 'occupationCode': '1019', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1020', 'subTypes': [] }, { 'occupationCode': '1021', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1022', 'subTypes': [] }, { 'occupationCode': '1023', 'subTypes': [] }, { 'occupationCode': '1024', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1025', 'subTypes': [] }, { 'occupationCode': '1026', 'subTypes': [] }, { 'occupationCode': '1027', 'subTypes': [] }, { 'occupationCode': '1028', 'subTypes': [] }, { 'occupationCode': '1029', 'subTypes': [] }, { 'occupationCode': '1030', 'subTypes': [] }, { 'occupationCode': '1031', 'subTypes': [] }, { 'occupationCode': '1032', 'subTypes': [] }, { 'occupationCode': '1033', 'subTypes': [] }, { 'occupationCode': '1034', 'subTypes': [] }, { 'occupationCode': '1035', 'subTypes': [] }, { 'occupationCode': '1036', 'subTypes': [] }, { 'occupationCode': '1037', 'subTypes': [] }, { 'occupationCode': '1038', 'subTypes': [] }, { 'occupationCode': '1039', 'subTypes': [] }, { 'occupationCode': '1040', 'subTypes': [] }, { 'occupationCode': '1041', 'subTypes': [] }, { 'occupationCode': '1042', 'subTypes': [] }, { 'occupationCode': '1043', 'subTypes': [] }, { 'occupationCode': '1044', 'subTypes': [] }, { 'occupationCode': '1045', 'subTypes': [] }, { 'occupationCode': '1046', 'subTypes': [] }, { 'occupationCode': '1047', 'subTypes': [] }, { 'occupationCode': '1048', 'subTypes': [] }, { 'occupationCode': '1049', 'subTypes': [] }, { 'occupationCode': '1050', 'subTypes': [] }, { 'occupationCode': '1051', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1052', 'subTypes': [] }, { 'occupationCode': '1053', 'subTypes': [] }, { 'occupationCode': '1054', 'subTypes': [] }, { 'occupationCode': '1055', 'subTypes': [] }, { 'occupationCode': '1056', 'subTypes': [] }, { 'occupationCode': '1057', 'subTypes': [] }, { 'occupationCode': '1058', 'subTypes': [] }, { 'occupationCode': '1059', 'subTypes': [] }, { 'occupationCode': '1060', 'subTypes': [] }] }, { 'category': '22', 'occupation': [{ 'occupationCode': '1061', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1062', 'subTypes': [] }, { 'occupationCode': '1063', 'subTypes': [] }, { 'occupationCode': '1064', 'subTypes': [] }, { 'occupationCode': '1065', 'subTypes': [] }, { 'occupationCode': '1066', 'subTypes': [] }, { 'occupationCode': '1067', 'subTypes': [] }, { 'occupationCode': '1068', 'subTypes': [] }, { 'occupationCode': '1069', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1070', 'subTypes': [] }, { 'occupationCode': '1071', 'subTypes': [] }, { 'occupationCode': '1072', 'subTypes': [] }, { 'occupationCode': '1073', 'subTypes': [] }, { 'occupationCode': '1074', 'subTypes': [] }, { 'occupationCode': '1075', 'subTypes': [] }, { 'occupationCode': '1076', 'subTypes': [] }, { 'occupationCode': '1077', 'subTypes': [] }, { 'occupationCode': '1078', 'subTypes': [] }, { 'occupationCode': '1079', 'subTypes': [] }, { 'occupationCode': '1080', 'subTypes': [] }, { 'occupationCode': '1081', 'subTypes': [] }, { 'occupationCode': '1082', 'subTypes': [] }, { 'occupationCode': '1083', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1084', 'subTypes': [] }, { 'occupationCode': '1085', 'subTypes': [] }, { 'occupationCode': '1086', 'subTypes': [] }, { 'occupationCode': '1087', 'subTypes': [] }, { 'occupationCode': '1088', 'subTypes': [] }, { 'occupationCode': '1089', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1090', 'subTypes': [] }, { 'occupationCode': '1091', 'subTypes': [] }, { 'occupationCode': '1092', 'subTypes': [] }, { 'occupationCode': '1093', 'subTypes': [] }, { 'occupationCode': '1094', 'subTypes': [] }, { 'occupationCode': '1095', 'subTypes': [] }, { 'occupationCode': '1096', 'subTypes': [] }, { 'occupationCode': '1097', 'subTypes': [] }, { 'occupationCode': '1098', 'subTypes': [] }, { 'occupationCode': '1099', 'subTypes': [] }, { 'occupationCode': '1100', 'subTypes': [] }, { 'occupationCode': '1101', 'subTypes': [] }, { 'occupationCode': '1102', 'subTypes': [] }, { 'occupationCode': '1103', 'subTypes': [] }, { 'occupationCode': '1104', 'subTypes': [] }, { 'occupationCode': '1105', 'subTypes': [] }, { 'occupationCode': '1106', 'subTypes': [] }, { 'occupationCode': '1107', 'subTypes': [] }, { 'occupationCode': '1108', 'subTypes': [] }, { 'occupationCode': '1109', 'subTypes': [] }, { 'occupationCode': '1110', 'subTypes': [] }, { 'occupationCode': '1111', 'subTypes': [] }, { 'occupationCode': '1112', 'subTypes': [] }, { 'occupationCode': '1113', 'subTypes': [] }, { 'occupationCode': '1114', 'subTypes': [] }, { 'occupationCode': '1115', 'subTypes': [] }, { 'occupationCode': '1116', 'subTypes': [] }, { 'occupationCode': '1117', 'subTypes': [] }, { 'occupationCode': '1118', 'subTypes': [] }, { 'occupationCode': '1119', 'subTypes': [] }, { 'occupationCode': '1120', 'subTypes': [] }, { 'occupationCode': '1121', 'subTypes': [] }, { 'occupationCode': '1122', 'subTypes': [] }, { 'occupationCode': '1123', 'subTypes': [] }, { 'occupationCode': '1124', 'subTypes': [] }, { 'occupationCode': '1125', 'subTypes': [] }, { 'occupationCode': '1126', 'subTypes': [] }, { 'occupationCode': '1127', 'subTypes': [] }, { 'occupationCode': '1128', 'subTypes': [] }] }, { 'category': '23', 'occupation': [{ 'occupationCode': '1129', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1130', 'subTypes': [] }, { 'occupationCode': '1131', 'subTypes': [] }, { 'occupationCode': '1132', 'subTypes': [] }, { 'occupationCode': '1133', 'subTypes': [] }, { 'occupationCode': '1134', 'subTypes': [] }, { 'occupationCode': '1135', 'subTypes': [] }, { 'occupationCode': '1136', 'subTypes': [] }, { 'occupationCode': '1137', 'subTypes': [] }, { 'occupationCode': '1138', 'subTypes': [] }, { 'occupationCode': '1139', 'subTypes': [] }, { 'occupationCode': '1140', 'subTypes': [] }, { 'occupationCode': '1141', 'subTypes': [] }, { 'occupationCode': '1142', 'subTypes': [] }, { 'occupationCode': '1143', 'subTypes': [] }, { 'occupationCode': '1144', 'subTypes': [] }, { 'occupationCode': '1145', 'subTypes': [] }, { 'occupationCode': '1146', 'subTypes': [] }, { 'occupationCode': '1147', 'subTypes': [] }, { 'occupationCode': '1148', 'subTypes': [] }, { 'occupationCode': '1149', 'subTypes': [] }, { 'occupationCode': '1150', 'subTypes': [] }, { 'occupationCode': '1151', 'subTypes': [] }, { 'occupationCode': '1152', 'subTypes': [] }, { 'occupationCode': '1153', 'subTypes': [] }, { 'occupationCode': '1154', 'subTypes': [] }, { 'occupationCode': '1155', 'subTypes': [] }, { 'occupationCode': '1156', 'subTypes': [] }, { 'occupationCode': '1157', 'subTypes': [] }, { 'occupationCode': '1158', 'subTypes': [] }, { 'occupationCode': '1159', 'subTypes': [] }, { 'occupationCode': '1160', 'subTypes': [] }, { 'occupationCode': '1161', 'subTypes': [] }] }, { 'category': '24', 'occupation': [{ 'occupationCode': '1162', 'subTypes': [35, 36, 37, 38, 39, 40, 41] }, { 'occupationCode': '1163', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1164', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1165', 'subTypes': [42, 43, 44, 45] }, { 'occupationCode': '1174', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1166', 'subTypes': [] }, { 'occupationCode': '1167', 'subTypes': [] }, { 'occupationCode': '1168', 'subTypes': [] }, { 'occupationCode': '1169', 'subTypes': [] }, { 'occupationCode': '1170', 'subTypes': [] }, { 'occupationCode': '1171', 'subTypes': [] }, { 'occupationCode': '1172', 'subTypes': [] }, { 'occupationCode': '1173', 'subTypes': [] }, { 'occupationCode': '1175', 'subTypes': [] }, { 'occupationCode': '1176', 'subTypes': [] }] }, { 'category': '25', 'occupation': [{ 'occupationCode': '1177', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1178', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1179', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1180', 'subTypes': [] }, { 'occupationCode': '1181', 'subTypes': [] }, { 'occupationCode': '1182', 'subTypes': [] }, { 'occupationCode': '1183', 'subTypes': [] }, { 'occupationCode': '1184', 'subTypes': [] }, { 'occupationCode': '1185', 'subTypes': [] }, { 'occupationCode': '1186', 'subTypes': [] }, { 'occupationCode': '1187', 'subTypes': [] }, { 'occupationCode': '1188', 'subTypes': [] }, { 'occupationCode': '1189', 'subTypes': [] }, { 'occupationCode': '1190', 'subTypes': [] }, { 'occupationCode': '1191', 'subTypes': [] }, { 'occupationCode': '1192', 'subTypes': [] }, { 'occupationCode': '1193', 'subTypes': [] }, { 'occupationCode': '1194', 'subTypes': [] }, { 'occupationCode': '1200', 'subTypes': [] }, { 'occupationCode': '1201', 'subTypes': [] }, { 'occupationCode': '1202', 'subTypes': [] }, { 'occupationCode': '1203', 'subTypes': [] }, { 'occupationCode': '1204', 'subTypes': [] }, { 'occupationCode': '1205', 'subTypes': [] }, { 'occupationCode': '1206', 'subTypes': [] }, { 'occupationCode': '1207', 'subTypes': [] }, { 'occupationCode': '1209', 'subTypes': [] }, { 'occupationCode': '1210', 'subTypes': [] }, { 'occupationCode': '1211', 'subTypes': [] }, { 'occupationCode': '1195', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1196', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1197', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1198', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1199', 'subTypes': [54, 55] }, { 'occupationCode': '1208', 'subTypes': [56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97] }] }, { 'category': '26', 'occupation': [{ 'occupationCode': '1212', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1213', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1214', 'subTypes': [] }, { 'occupationCode': '1215', 'subTypes': [] }, { 'occupationCode': '1216', 'subTypes': [] }, { 'occupationCode': '1217', 'subTypes': [] }, { 'occupationCode': '1218', 'subTypes': [] }, { 'occupationCode': '1219', 'subTypes': [] }, { 'occupationCode': '1220', 'subTypes': [] }, { 'occupationCode': '1221', 'subTypes': [] }, { 'occupationCode': '1222', 'subTypes': [] }, { 'occupationCode': '1223', 'subTypes': [] }, { 'occupationCode': '1224', 'subTypes': [] }, { 'occupationCode': '1225', 'subTypes': [] }, { 'occupationCode': '1226', 'subTypes': [] }, { 'occupationCode': '1227', 'subTypes': [] }, { 'occupationCode': '1228', 'subTypes': [] }, { 'occupationCode': '1229', 'subTypes': [] }, { 'occupationCode': '1230', 'subTypes': [] }, { 'occupationCode': '1231', 'subTypes': [] }, { 'occupationCode': '1232', 'subTypes': [] }, { 'occupationCode': '1233', 'subTypes': [] }, { 'occupationCode': '1234', 'subTypes': [] }, { 'occupationCode': '1235', 'subTypes': [] }, { 'occupationCode': '1236', 'subTypes': [] }, { 'occupationCode': '1237', 'subTypes': [] }, { 'occupationCode': '1238', 'subTypes': [] }, { 'occupationCode': '1239', 'subTypes': [] }, { 'occupationCode': '1240', 'subTypes': [] }, { 'occupationCode': '1241', 'subTypes': [] }, { 'occupationCode': '1242', 'subTypes': [] }, { 'occupationCode': '1243', 'subTypes': [] }, { 'occupationCode': '1244', 'subTypes': [] }] }, { 'category': '27', 'occupation': [{ 'occupationCode': '1245', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1246', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1247', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1249', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1254', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1256', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1248', 'subTypes': [] }, { 'occupationCode': '1250', 'subTypes': [] }, { 'occupationCode': '1251', 'subTypes': [] }, { 'occupationCode': '1252', 'subTypes': [] }, { 'occupationCode': '1253', 'subTypes': [] }, { 'occupationCode': '1255', 'subTypes': [] }, { 'occupationCode': '1257', 'subTypes': [] }, { 'occupationCode': '1258', 'subTypes': [] }, { 'occupationCode': '1259', 'subTypes': [] }, { 'occupationCode': '1260', 'subTypes': [] }, { 'occupationCode': '1261', 'subTypes': [] }, { 'occupationCode': '1262', 'subTypes': [] }, { 'occupationCode': '1263', 'subTypes': [] }, { 'occupationCode': '1264', 'subTypes': [] }, { 'occupationCode': '1265', 'subTypes': [] }, { 'occupationCode': '1266', 'subTypes': [] }, { 'occupationCode': '1267', 'subTypes': [] }, { 'occupationCode': '1268', 'subTypes': [] }, { 'occupationCode': '1269', 'subTypes': [] }, { 'occupationCode': '1270', 'subTypes': [] }, { 'occupationCode': '1271', 'subTypes': [] }, { 'occupationCode': '1272', 'subTypes': [] }, { 'occupationCode': '1273', 'subTypes': [] }, { 'occupationCode': '1274', 'subTypes': [] }, { 'occupationCode': '1275', 'subTypes': [] }, { 'occupationCode': '1276', 'subTypes': [] }, { 'occupationCode': '1277', 'subTypes': [] }, { 'occupationCode': '1278', 'subTypes': [] }, { 'occupationCode': '1279', 'subTypes': [] }, { 'occupationCode': '1280', 'subTypes': [] }, { 'occupationCode': '1281', 'subTypes': [] }, { 'occupationCode': '1282', 'subTypes': [] }, { 'occupationCode': '1283', 'subTypes': [] }, { 'occupationCode': '1284', 'subTypes': [] }, { 'occupationCode': '1285', 'subTypes': [] }, { 'occupationCode': '1286', 'subTypes': [] }, { 'occupationCode': '1287', 'subTypes': [] }, { 'occupationCode': '1288', 'subTypes': [] }, { 'occupationCode': '1289', 'subTypes': [] }, { 'occupationCode': '1290', 'subTypes': [] }, { 'occupationCode': '1291', 'subTypes': [] }, { 'occupationCode': '1292', 'subTypes': [] }, { 'occupationCode': '1293', 'subTypes': [] }, { 'occupationCode': '1294', 'subTypes': [] }] }, { 'category': '28', 'occupation': [{ 'occupationCode': '1295', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1296', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1297', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1298', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1308', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1299', 'subTypes': [] }, { 'occupationCode': '1300', 'subTypes': [] }, { 'occupationCode': '1301', 'subTypes': [] }, { 'occupationCode': '1302', 'subTypes': [] }, { 'occupationCode': '1303', 'subTypes': [] }, { 'occupationCode': '1304', 'subTypes': [] }, { 'occupationCode': '1305', 'subTypes': [] }, { 'occupationCode': '1306', 'subTypes': [] }, { 'occupationCode': '1307', 'subTypes': [] }, { 'occupationCode': '1309', 'subTypes': [] }, { 'occupationCode': '1310', 'subTypes': [] }, { 'occupationCode': '1311', 'subTypes': [] }, { 'occupationCode': '1312', 'subTypes': [] }, { 'occupationCode': '1313', 'subTypes': [] }, { 'occupationCode': '1314', 'subTypes': [] }, { 'occupationCode': '1315', 'subTypes': [] }, { 'occupationCode': '1316', 'subTypes': [] }, { 'occupationCode': '1317', 'subTypes': [] }, { 'occupationCode': '1318', 'subTypes': [] }, { 'occupationCode': '1319', 'subTypes': [] }, { 'occupationCode': '1320', 'subTypes': [] }, { 'occupationCode': '1321', 'subTypes': [] }, { 'occupationCode': '1322', 'subTypes': [] }, { 'occupationCode': '1323', 'subTypes': [] }, { 'occupationCode': '1324', 'subTypes': [] }, { 'occupationCode': '1325', 'subTypes': [] }, { 'occupationCode': '1326', 'subTypes': [] }, { 'occupationCode': '1327', 'subTypes': [] }, { 'occupationCode': '1328', 'subTypes': [] }, { 'occupationCode': '1329', 'subTypes': [] }, { 'occupationCode': '1330', 'subTypes': [] }, { 'occupationCode': '1331', 'subTypes': [] }, { 'occupationCode': '1332', 'subTypes': [] }, { 'occupationCode': '1333', 'subTypes': [] }, { 'occupationCode': '1334', 'subTypes': [] }, { 'occupationCode': '1335', 'subTypes': [] }, { 'occupationCode': '1336', 'subTypes': [] }, { 'occupationCode': '1337', 'subTypes': [] }, { 'occupationCode': '1338', 'subTypes': [] }, { 'occupationCode': '1339', 'subTypes': [] }, { 'occupationCode': '1340', 'subTypes': [] }, { 'occupationCode': '1341', 'subTypes': [] }, { 'occupationCode': '1342', 'subTypes': [] }, { 'occupationCode': '1343', 'subTypes': [] }, { 'occupationCode': '1344', 'subTypes': [] }, { 'occupationCode': '1345', 'subTypes': [] }, { 'occupationCode': '1346', 'subTypes': [] }, { 'occupationCode': '1347', 'subTypes': [] }, { 'occupationCode': '1348', 'subTypes': [] }, { 'occupationCode': '1349', 'subTypes': [] }, { 'occupationCode': '1350', 'subTypes': [] }, { 'occupationCode': '1351', 'subTypes': [] }, { 'occupationCode': '1352', 'subTypes': [] }, { 'occupationCode': '1353', 'subTypes': [] }, { 'occupationCode': '1354', 'subTypes': [] }, { 'occupationCode': '1355', 'subTypes': [] }, { 'occupationCode': '1356', 'subTypes': [] }, { 'occupationCode': '1357', 'subTypes': [] }, { 'occupationCode': '1358', 'subTypes': [] }] }, { 'category': '29', 'occupation': [{ 'occupationCode': '1362', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1363', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1364', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1365', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1366', 'subTypes': [] }, { 'occupationCode': '1367', 'subTypes': [] }, { 'occupationCode': '1368', 'subTypes': [] }, { 'occupationCode': '1369', 'subTypes': [] }, { 'occupationCode': '1370', 'subTypes': [] }, { 'occupationCode': '1371', 'subTypes': [] }, { 'occupationCode': '1372', 'subTypes': [] }, { 'occupationCode': '1373', 'subTypes': [] }, { 'occupationCode': '1359', 'subTypes': [] }, { 'occupationCode': '1360', 'subTypes': [] }, { 'occupationCode': '1361', 'subTypes': [] }] }, { 'category': '30', 'occupation': [{ 'occupationCode': '1374', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1375', 'subTypes': [1, 2, 3] }, { 'occupationCode': '1376', 'subTypes': [] }, { 'occupationCode': '1377', 'subTypes': [] }, { 'occupationCode': '1378', 'subTypes': [] }, { 'occupationCode': '1379', 'subTypes': [] }, { 'occupationCode': '1380', 'subTypes': [] }, { 'occupationCode': '1381', 'subTypes': [] }, { 'occupationCode': '1382', 'subTypes': [] }, { 'occupationCode': '1383', 'subTypes': [] }, { 'occupationCode': '1384', 'subTypes': [] }, { 'occupationCode': '1385', 'subTypes': [] }, { 'occupationCode': '1386', 'subTypes': [] }, { 'occupationCode': '1387', 'subTypes': [] }, { 'occupationCode': '1388', 'subTypes': [] }, { 'occupationCode': '1389', 'subTypes': [] }, { 'occupationCode': '1390', 'subTypes': [] }, { 'occupationCode': '1391', 'subTypes': [] }, { 'occupationCode': '1392', 'subTypes': [] }, { 'occupationCode': '1393', 'subTypes': [] }, { 'occupationCode': '1394', 'subTypes': [] }, { 'occupationCode': '1395', 'subTypes': [] }, { 'occupationCode': '1396', 'subTypes': [] }, { 'occupationCode': '1397', 'subTypes': [] }, { 'occupationCode': '1398', 'subTypes': [] }, { 'occupationCode': '1399', 'subTypes': [] }, { 'occupationCode': '1400', 'subTypes': [] }, { 'occupationCode': '1401', 'subTypes': [] }] }, { 'category': '31', 'occupation': [{ 'occupationCode': '1402', 'subTypes': [] }] }, { 'category': '32', 'occupation': [{ 'occupationCode': '1403', 'subTypes': [] }] }, { 'category': '33', 'occupation': [{ 'occupationCode': '1404', 'subTypes': [] }] }, { 'category': '34', 'occupation': [{ 'occupationCode': '1405', 'subTypes': [] }] }, { 'category': '35', 'occupation': [{ 'occupationCode': '1406', 'subTypes': [] }] }, { 'category': '36', 'occupation': [{ 'occupationCode': '1407', 'subTypes': [] }] }, { 'category': '37', 'occupation': [{ 'occupationCode': '1408', 'subTypes': [98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142] }] }] };

    ngOnInit(): void {

    }

    setEleScriptIntValues(commFun: FormUtlityCommanFunction, tempObj: localTempObject,
        parentObj: any, enumObj: any, lang: any) {
        try {
            this.eleScriformUliFunObj = commFun;
            this.eleScritempLocalObj = tempObj;
            this.parentObj = parentObj;
            this.EnumData = enumObj;
            this.lang = lang;
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > setEleScriptIntValues ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    mailingAddressSame(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let tempIsChecked = evt.target.checked;
            let currAddrObj = appDataObj.borrowers[0].current_residence;
            let mailAddrObj = appDataObj.borrowers[0].mailing_address;
            this.eleScriformUliFunObj.getValuesForModel(buildObj.formGroup_value,
                this.eleScritempLocalObj, appDataObj, evt.target.checked, true);
            if (tempIsChecked) {
                mailAddrObj.address1 = currAddrObj.address1;
                mailAddrObj.address2 = currAddrObj.address2;
                mailAddrObj.county = currAddrObj.county;
                mailAddrObj.csz = currAddrObj.city + ' ' + currAddrObj.state + ' ' + currAddrObj.zip;
            } else {
                mailAddrObj.address1 = '';
                mailAddrObj.address2 = '';
                mailAddrObj.county = '';
                mailAddrObj.csz = '';
            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > mailingAddressSame ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    createCoBorrower(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (appDataObj.borrowers.length === 1) {
                let borrObj: Borrower = new Borrower();
                appDataObj.borrowers.push(borrObj);
            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > createCoBorrower ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    removeCoBorrower(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (appDataObj.borrowers.length === 2) {
                appDataObj.borrowers.pop();
            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > removeCoBorrower ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onEmployerChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmployerChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onSrcPrprtyPrchsChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmployerChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    ChangeLiability(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            if (appDataObj.Liability_Type == "5" || appDataObj.Liability_Type == "6") {
                appDataObj.cibc_Instrument_Indicator = "";
                appDataObj.Creditor_Name = "";
            }
            let tempObj: any = this.eleScritempLocalObj.temp;
            let liability_type = formGroupObj.get('B1_CurrentLiablities_new_LiabilityType').value;
            if (appDataObj.Liability_Source !== 'CVD') {
                tempObj.showMaturityDate = "true";
            } else {


                if (liability_type == '0' || liability_type == '302' || liability_type == '300' || liability_type == 'MTG') {
                    tempObj.showMaturityDate = "true";
                } else {
                    tempObj.showMaturityDate = "false";
                }

            }


            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeLiability ::: Function in  - > form-elementScript-function.ts', e)
        }
    }
    onChangePayOut(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onChangePayOut ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onChangePayOutForRental(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (formGroupObj.controls.B1_RentalLiablities_edited_PayOut.value == "1")
                appDataObj.Source_of_Funds = "1";
            else
                appDataObj.Source_of_Funds = "";
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onChangePayOut ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    ChangeReferrelType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (formGroupObj.controls.B1_Deal_Contact_New_ReferralType.value == 2) {
                formGroupObj.controls.B1_Deal_Contact_New_ReferralCode.setValue('Self');
            } else if (formGroupObj.controls.B1_Deal_Contact_New_ReferralType.value == 5) {
                formGroupObj.controls.B1_Deal_Contact_New_ReferralCode.setValue('TREBS');
            } else if (formGroupObj.controls.B1_Deal_Contact_New_ReferralType.value == 6) {
                formGroupObj.controls.B1_Deal_Contact_New_ReferralCode.setValue('TRFLM');
            } else if (formGroupObj.controls.B1_Deal_Contact_New_ReferralType.value == 7) {
                formGroupObj.controls.B1_Deal_Contact_New_ReferralCode.setValue('TR40792');
            } else {
                formGroupObj.controls.B1_Deal_Contact_New_ReferralCode.setValue('');
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeReferrelType ::: Function in  - > form-elementScript-function.ts', e)
        }
    }
    onThirdParty1(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - >  ::: Function in  onThirdParty1- > form-elementScript-function.ts', e);
        }
    }


    onResidentialStatusChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onResidentialStatusChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onChangeOfAssetType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeAsset Type ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onChangeOfDwellingType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (evt.target.value.toString() == '7' && appDataObj.deal_details.mdiObj.mi_provider === '') {
                appDataObj.deal_details.mdiObj.mi_provider = '1';
                appDataObj.deal_details.mdiObj.default_insurance_required = 'Y';
                appDataObj.deal_details.mdiObj.insurance_included_in_mortgage = 'Y';
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeDwelling Type ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onChangeOfIncomeType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let fldName = buildObj.formGroup_key
            let fldValue = formGroupObj.get(fldName).value;
           /* Defect #233 Fix
           if (fldValue === "2" || fldValue === "3") {
                appDataObj.employment_info.income_type = fldValue;
               appDataObj.employment_info.income_frequency = "8";
                this.parentObj.onViewRefresh();
            }
            else */ if (fldValue === "4") {
                appDataObj.employment_info.income_type = fldValue;
                appDataObj.employment_info.income_frequency = "1";
                this.parentObj.onViewRefresh();
            }
            else {
                this.parentObj.refreshOnDemand(formGroupObj);
            }

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeIncome Type ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onChangeOfIncomeFrequency(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeIncome Frequency ::: Function in  - > form-elementScript-function.ts', e);
        }
    }


    onPropertyOccupancyChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangePropertyOccupancy Type ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onHasLiabilityChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeHasLiability ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    ChangeCreditorAndFI(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (formGroupObj.value.B1_AddNewAssets_HeldwithCIBC === 'Y') {
                formGroupObj.get('B1_AddNewAssets_FinancialInstitutionName').setValue('CIBC');
                formGroupObj.get('B1_AddNewAssets_FinancialInstitutionType').setValue('1');
               
            } else {
                formGroupObj.get('B1_AddNewAssets_FinancialInstitutionName').setValue('');
                formGroupObj.get('B1_AddNewAssets_FinancialInstitutionType').setValue('');
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeCreditorAndFI ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onRateDiscountDataChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (formGroupObj.value.B1_LoanRequestDetails_RateDiscount !== '' && formGroupObj.value.B1_LoanRequestDetails_RateDiscount !== undefined) {
                const posted_rate = appDataObj.posted_rate.slice(0, appDataObj.posted_rate.length - 1);
                appDataObj.client_rate = Number(posted_rate) - Number(formGroupObj.value.B1_LoanRequestDetails_RateDiscount);
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onRateDiscountDataChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onProductInterestDiscountChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
           
            if (formGroupObj.valid) {
                const rateWithoutPercent = appDataObj.posted_rate.slice(0, appDataObj.posted_rate.length - 1);
                const interestRateDiscount = Number(formGroupObj.value.B1_RateHold_Product_Selection2_InterestRateDiscount);
                const fixDecimalForValue: any = Number(rateWithoutPercent - interestRateDiscount).toFixed(2) + ' %';
                formGroupObj.get('B1_RateHold_Product_Selection2_ClientRate').setValue(fixDecimalForValue);
                formGroupObj.get('B1_RateHold_Product_Selection2_ClientRate').updateValueAndValidity();
            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onProductInterestDiscountChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onEmploymentStatusChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmploymentStatusChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }


    onMortgageInsuranceDataChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            // made changes for PNI bcz we are sending whole dealobj as appDataObj
            const mi_providers = this.EnumData['MORTGAGE_INSURANCE_PROVIDER'];
            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = [];
            let mi_provider;
            if (buildObj.formGroup_formName === 'PNI_MortgageProduct') {
                mi_provider = formGroupObj.get('PNI_MortgageProduct_MortgageInsurerType').value;
                formGroupObj.get('PNI_MortgageProduct_MIProductSpecialProgram').setValue('');
            } else {
                mi_provider = formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsuranceProvider').value;
                formGroupObj.get('B1_ProdDet_MortgageDetails_MIProductSpecialProgram').setValue('');
            }
            if (mi_provider != null) {
                const mi_program = appDataObj.deal_details.mdiObj.mi_product_program ? appDataObj.deal_details.mdiObj.mi_product_program : '';

                switch (Number(mi_provider)) {
                    case 1:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_CMHC_SPECIAL_PROGRAM'];
                        }
                        break;
                    case 2:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_CANADA_GUARANTY_SPECIAL_PROGRAM'];
                        }
                        break;
                    case 3:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_GENWORTH_SPECIAL_PROGRAM'];
                        }
                        break;
                    default:
                        {
                            this.EnumData['MORTGAGE_INSURANCE_PROGRAM'] = this.EnumData['MORTGAGE_COMMON_SPECIAL_PROGRAM'];
                        }
                        break;

                }


            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onMortgageInsuranceDataChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onOccupationDataChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = [];
            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = [];
            const occupation_category = appDataObj.employment_info.occupation_category;
            const occupation_description = appDataObj.employment_info.occupation_description;
            const occupation_types = this.occupation_data.occupationDetails.find(occupation => occupation.category.toString().toLowerCase() === occupation_category.toString().toLowerCase());
            const tempOccupationTypeDesc = [];
            const tempOccupationTypeSubDesc = [];
            if (occupation_types) {
                occupation_types.occupation.forEach(occupation => {
                    const enumMatchType = this.EnumData['OCCUPATION_TYPE_DESCRIPTION'].find(
                        enumData => enumData.keyCode.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase());
                    if (occupation_description && occupation_description.toString().toLowerCase() === occupation.occupationCode.toLowerCase()) {
                        occupation.subTypes.forEach(subType => {
                            const enumMatchSubType = this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION'].find(
                                enumData => enumData.keyCode.toString().toLowerCase() === subType.toString().toLowerCase());
                            tempOccupationTypeSubDesc.push(enumMatchSubType);
                        });
                        this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = tempOccupationTypeSubDesc;
                    }
                    tempOccupationTypeDesc.push(enumMatchType);
                });
                this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = tempOccupationTypeDesc;
            }

            this.parentObj.refreshOnDemand(formGroupObj);



        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onOccupationDataChange ::: Function in  - > form-elementScript-function.ts', e);

        }
    }
    onThirdParty(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        //  // debugger;
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmploymentStatusChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onThirdPartyType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
           
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmploymentStatusChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onCreditorTypeChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let baseName = buildObj.formGroup_formName;
            let fld_NameStr = baseName + "_CreditorName";
            let fld_TypeStr = baseName + "_CreditorType";
            let fld_CIBCLibStr = baseName + "_CIBCLiability";

            if (formGroupObj.get(fld_TypeStr).value === '1'
                && formGroupObj.get(fld_NameStr).value === '87') {
                formGroupObj.get(fld_CIBCLibStr).setValue(true);
                appDataObj.cibc_Instrument_Indicator = "Y";
            } else {
                formGroupObj.get(fld_CIBCLibStr).setValue(false);
                appDataObj.cibc_Instrument_Indicator = "N";
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onCreditorTypeChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onCreditorNameChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let baseName = buildObj.formGroup_formName;
            let fld_NameStr = baseName + "_CreditorName";
            let fld_TypeStr = baseName + "_CreditorType";
            let fld_CIBCLibStr = baseName + "_CIBCLiability";

            if (formGroupObj.get(fld_TypeStr).value === '1'
                && formGroupObj.get(fld_NameStr).value === '87') {
                formGroupObj.get(fld_CIBCLibStr).setValue(true);
                appDataObj.cibc_Instrument_Indicator = "Y";
            } else {
                formGroupObj.get(fld_CIBCLibStr).setValue(false);
                appDataObj.cibc_Instrument_Indicator = "N";

            }
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onCreditorNameChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onCIBC_LiabilityClicked(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            let baseName = buildObj.formGroup_formName;
            let fld_NameStr = baseName + "_CreditorName";
            let fld_TypeStr = baseName + "_CreditorType"

            let isCIBCSelected = evt.target.checked;
            if (isCIBCSelected) {
                appDataObj.cibc_Instrument_Indicator = "Y";
                if (formGroupObj.get(fld_TypeStr)) {
                    formGroupObj.get(fld_TypeStr).setValue("1");
                }
                if (formGroupObj.get(fld_NameStr)) {
                    formGroupObj.get(fld_NameStr).setValue("87");
                }
            } else {
                appDataObj.cibc_Instrument_Indicator = "N";
                if (formGroupObj.get(fld_TypeStr)) {
                    formGroupObj.get(fld_TypeStr).setValue("");
                }
                if (formGroupObj.get(fld_NameStr)) {
                    formGroupObj.get(fld_NameStr).setValue("");
                }
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onCIBC_LiabilityClicked ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onCIBC_TaxReturnsClicked(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
             this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error -> OnCIBC_TaxReturnsClicked ::: Function in - > form-elementScript-function.ts', e);
        }
    }
    onPayOutChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (appDataObj.Pay_Out !== '3') {
                appDataObj.Source_of_Funds = '1';
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onPayOutChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }
    onCurrentAddress_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            appDataObj.current_residence.direction = "";
            appDataObj.current_residence.state = "";
            appDataObj.current_residence.zip = "";
            appDataObj.current_residence.Province = "";
            appDataObj.current_residence.address1 = "";
            appDataObj.current_residence.address2 = "";
            appDataObj.current_residence.city = "";
            let tempLoc: any = this.eleScritempLocalObj.temp;
            tempLoc.current_residence.address_line1 = '';
            tempLoc.current_residence.address_line2 = '';
            appDataObj.current_residence.country = formGroupObj.get(evt.target.id).value;
            this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onMailing_CountryChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onMailing_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            appDataObj.mailing_address.direction = "";
            appDataObj.mailing_address.state = "";
            appDataObj.mailing_address.zip = "";
            appDataObj.mailing_address.Province = "";
            appDataObj.mailing_address.address1 = "";
            appDataObj.mailing_address.address2 = "";
            appDataObj.mailing_address.city = "";
            let tempLoc: any = this.eleScritempLocalObj.temp;
            tempLoc.mailing_address.addressLine1 = '';
            tempLoc.mailing_address.addressLine2 = '';
            appDataObj.mailing_address.country = formGroupObj.get(evt.target.id).value;
            this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onMailing_CountryChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onCurrent_Residence_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            appDataObj.current_residence.direction = "";
            appDataObj.current_residence.state = "";
            appDataObj.current_residence.zip = "";
            appDataObj.current_residence.Province = "";
            appDataObj.current_residence.address1 = "";
            appDataObj.current_residence.address2 = "";
            appDataObj.current_residence.city = "";
            let tempLoc: any = this.eleScritempLocalObj.temp;
            tempLoc.current_residence.addressLine1 = '';
            tempLoc.current_residence.addressLine2 = '';
            appDataObj.current_residence.country = formGroupObj.get(evt.target.id).value;
            this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onCurrent_Residence_CountryChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onEmployment_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let formName = buildObj.formGroup_formName;
            let mailAddrName = "Mailing_Address";
            let cuntPreName = "OT";
            let resetFormName = formName + "_" + mailAddrName + "_";
            let curcoutSelect = formGroupObj.get(buildObj.formGroup_key).value;
            let coutSelect = appDataObj.employment_info.country;
            if (coutSelect === "146") {
                cuntPreName = "CA";
            } else if (coutSelect === "110") {
                cuntPreName = "US";
            }
            resetFormName += cuntPreName;
            let curFromObj = formGroupObj.get(resetFormName);
            if (curFromObj) {
                for (let obj in curFromObj.value) {
                    curFromObj.get(obj).setValue("");
                }
            }
            //  for not to make country field as empty...
            if (curcoutSelect === '') {
                formGroupObj.get(evt.target.id).setValue("146")
            }
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmployment_CountryChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onMailing_Asset_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            appDataObj.AddressLine_1 = '';
            appDataObj.AddressLine_2 = '';
            appDataObj.City = '';
            appDataObj.Direction = '';
            appDataObj.Province = '';
            appDataObj.Postal_Code = '';
            if (evt.target.value === '') {
                formGroupObj.get(evt.target.id).setValue("146")
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onMailing_Asset_CountryChange ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onPurchasePriceChanges(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
           
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onPurchasePriceChanges ::: Function in  - > form-elementScript-function.ts', e)
        }
    }
    onAppraisedValueChanges(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
           
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onAppraisedValueChanges ::: Function in  - > form-elementScript-function.ts', e)
        }
    }
    onEstimatedValueChanges(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
          
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEstimatedValueChanges ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    ChangeMortgageAmount(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.calculateLTV(evt, buildObj, formGroupObj, appDataObj);
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeLiability ::: Function in  - > form-elementScript-function.ts', e)
        }
    }


    ChangeMortgageAmountNoDefault(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let val = formGroupObj.get('B1_ProdDet_MortgageDetails_DefaultInsuranceRequired').value;
            formGroupObj.get('B1_ProdDet_MortgageDetails_DefaultInsuranceRequired').setValue(val);
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeLiability ::: Function in  - > form-elementScript-function.ts', e)
        }
    }


    onMortgagePurposeChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.calculateLTV(evt, buildObj, formGroupObj, appDataObj);
            this.parentObj.refreshOnDemand(formGroupObj);
            window.scroll(window.pageXOffset - 1, window.pageYOffset - 1);
            //this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > Change Mortgage ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onBlendRate(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onEmploymentStatusChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onChargeAmountChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            let requestedMortgageAmount = appDataObj.transaction_details.deal_amount;
            let requestedPLCAmount = appDataObj.deal_details.plc.plc_requested_Limit;


            //let clientRate = appDataObj.percentage_of_client_rate;
            //let appraisedValue = appDataObj.deal_details.appraised_value
            let ihppLimit = 0;//formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').value;

            requestedMortgageAmount = requestedMortgageAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            requestedPLCAmount = requestedPLCAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

            if (formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit') && formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').value !== '') {
                ihppLimit = parseFloat(formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').value);
            } else if ((requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') &&
                (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '')) {
                ihppLimit = (parseFloat(requestedMortgageAmount) + parseFloat(requestedPLCAmount));
            } else if (requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') {
                ihppLimit = parseFloat(requestedMortgageAmount);
            } else if (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '') {
                ihppLimit = parseFloat(requestedPLCAmount);
            } else {
                ihppLimit = 0;
            }

            if (ihppLimit && ihppLimit.toString() !== '') {
                formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').setValue((ihppLimit.toFixed(2)).toString());
            } else {
                appDataObj.deal_details.plc.hpp_limit = '0';
            }


            let chargeAmountOption = formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmountOption').value;
            let chargeAmount = formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').value;


            if (chargeAmountOption) {
                if (chargeAmountOption === '1') {
                  
                    if (appDataObj.deal_details.purchase_price && appDataObj.deal_details.purchase_price !== '') {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue(appDataObj.deal_details.purchase_price.toString());
                    } else if (appDataObj.property_details.estimated_property_value && appDataObj.property_details.estimated_property_value !== '') {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue(appDataObj.property_details.estimated_property_value.toString());
                    } else if (appDataObj.property_details.appraised_value && appDataObj.property_details.appraised_value !== '') {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue(appDataObj.property_details.appraised_value.toString());
                    } else {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue('0');
                    }
                }
                if (chargeAmountOption === '2') {
                    if (ihppLimit && ihppLimit.toString() !== '') {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue(ihppLimit);
                        appDataObj.deal_details.plc.hppSectionDetails.charge_amount = ihppLimit;
                    }
                    else {
                        formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue('0');
                    }
                }

                this.parentObj.refreshOnDemand(formGroupObj);

            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onProductInterestDiscountChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    onChargeAmountChangeForWizard(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            let requestedMortgageAmount = appDataObj.transaction_details.deal_amount;
            let requestedPLCAmount = appDataObj.deal_details.plc.plc_requested_Limit;
            let ihppLimit = 0;//formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').value;

            requestedMortgageAmount = requestedMortgageAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            requestedPLCAmount = requestedPLCAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

            if (formGroupObj.get('B1_PNI_PLCAdditionalInformation_HPPLimit') && formGroupObj.get('B1_PNI_PLCAdditionalInformation_HPPLimit').value !== '') {
                ihppLimit = parseFloat(formGroupObj.get('B1_PNI_PLCAdditionalInformation_HPPLimit').value);
            } else if ((requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') &&
                (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '')) {
                ihppLimit = (parseFloat(requestedMortgageAmount) + parseFloat(requestedPLCAmount));
            } else if (requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') {
                ihppLimit = parseFloat(requestedMortgageAmount);
            } else if (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '') {
                ihppLimit = parseFloat(requestedPLCAmount);
            } else {
                ihppLimit = 0;
            }

            if (ihppLimit && ihppLimit.toString() !== '') {
                formGroupObj.get('B1_PNI_PLCAdditionalInformation_HPPLimit').setValue((ihppLimit.toFixed(2)).toString());
            } else {
                appDataObj.deal_details.plc.hpp_limit = '0';
            }
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onChargeAmountChangeForWizard ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    oncalculateClientRatePercentageChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
       
        if (formGroupObj.value['B1_ProdDet_MortgageProduct_Discount']) {
            appDataObj.deal_details.mortgageObj.mortgage_discount_rate = formGroupObj.value['B1_ProdDet_MortgageProduct_Discount']
        }

        let clientRate: any = '0';
        let postedRate: any = '0';
        let discount: any = '0';
        let appraisedValue: any = '0';
        let blendedRate: any = '0';



        if (appDataObj.deal_details.mortgageObj.mortgage_discount_rate) discount = appDataObj.deal_details.mortgageObj.mortgage_discount_rate;
        if (appDataObj.deal_details.mortgageObj.mortgage_client_rate) postedRate = appDataObj.deal_details.mortgageObj.mortgage_client_rate;
        if (appDataObj.deal_details.appraised_value) appraisedValue = appDataObj.deal_details.appraised_value;
        if (((appDataObj.deal_details.mortgage_purpose == 'M' || appDataObj.deal_details.mortgage_purpose == 'R' ||
            appDataObj.deal_details.mortgage_purpose == 'X')) && appDataObj.deal_details.mortgageObj.blended_rate == 'Y') {
            if (appDataObj.deal_details.mortgageObj.blended_rate_term) blendedRate = appDataObj.deal_details.mortgageObj.blended_rate_term
        } else {
            blendedRate = '0';
        }

        postedRate = postedRate.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
        discount = discount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
        appraisedValue = appraisedValue.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
        blendedRate = blendedRate.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

        if (appDataObj.deal_details.mortgageObj.mortgage_rate_type === 'Fixed') {
            clientRate = (parseFloat(postedRate) - parseFloat(discount) + parseFloat(blendedRate));
            if (appDataObj.deal_details.mortgageObj.rate_guaranteed_or_discount_period) {
                appDataObj.deal_details.mortgageObj.rate_guaranteed_or_discount_period = '120';
            }

        } else if (appDataObj.deal_details.mortgageObj.mortgage_rate_type === 'Variable') {
            //Product details pending to complete the calculation]
            clientRate = (parseFloat(postedRate) - parseFloat(discount) + parseFloat(blendedRate));
            if (appDataObj.deal_details.mortgageObj.rate_guaranteed_or_discount_period) {
                appDataObj.deal_details.mortgageObj.rate_guaranteed_or_discount_period = '30';
            }
        }
        appDataObj.deal_details.mortgageObj.mortgage_client_rate = clientRate;
        //postedRate =  appDataObj.deal_details.mortgage_client_rate;
        this.parentObj.refreshOnDemand(formGroupObj);
    }

    calculateLTV(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {

            let requestedAmount = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.transaction_details.deal_amount, this.lang);
            let purchasePrice = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.deal_details.purchase_price, this.lang);
            let estimatedValue = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.property_details.estimated_property_value, this.lang);
            let appraisedValue: any;//= this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.property_details.appraised_value,this.lang);
            let hppLimitAmount = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.deal_details.plc.hpp_limit, this.lang);
            let totalPriorCharge = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.property_details.total_prior_charge, this.lang);
            let assignedValue = this.eleScriformUliFunObj.getOnlyCurrencyValue(appDataObj.property_details.appraised_value, this.lang);
            let LTV = 0;
            totalPriorCharge = (totalPriorCharge && totalPriorCharge !== '') ? totalPriorCharge : '0';

            if (estimatedValue && estimatedValue !== '') {
                appraisedValue = estimatedValue;
                appraisedValue = this.eleScriformUliFunObj.getOnlyCurrencyValue(appraisedValue, this.lang);
            } else if (purchasePrice && purchasePrice !== '') {
                appraisedValue = purchasePrice;
                appraisedValue = this.eleScriformUliFunObj.getOnlyCurrencyValue(appraisedValue, this.lang);
            } else if (assignedValue && assignedValue !== '') {
                appraisedValue = assignedValue;
                appraisedValue = this.eleScriformUliFunObj.getOnlyCurrencyValue(appraisedValue, this.lang);
            }


            if (requestedAmount && requestedAmount.toString().length > 0) {
                if (appDataObj.deal_details.selectedProductName !== undefined && appDataObj.deal_details.selectedProductName !== null && appDataObj.deal_details.selectedProductName !== '') {
                    if (appDataObj.deal_details.selectedProductName === 'HPM') {
                        LTV = ((parseFloat(hppLimitAmount) + parseFloat(totalPriorCharge)) / (parseFloat(appraisedValue))) * 100;

                    } else if (appDataObj.deal_details.selectedProductName === 'M') {
                        LTV = ((parseFloat(requestedAmount) + parseFloat(totalPriorCharge)) / (parseFloat(appraisedValue))) * 100;

                    } else {
                        LTV = ((parseFloat(requestedAmount) + parseFloat(totalPriorCharge)) / (parseFloat(appraisedValue))) * 100;

                    }
                }
                if (appDataObj.deal_details.mdiObj.default_insurance_required === undefined) {
                    appDataObj.deal_details.mdiObj['default_insurance_required'] = '';
                }
                if ((LTV) > 80) {
                    formGroupObj.get('B1_ProdDet_MortgageDetails_DefaultInsuranceRequired').setValue('Y');
                    //  appDataObj.deal_details.mdiObj.default_insurance_required = 'Y';
                    //468: issue5 update
                    //formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').setValue('Y');

                    if (appDataObj.deal_details.mdiObj.insurance_included_in_mortgage === undefined) {
                        appDataObj.deal_details.mdiObj['insurance_included_in_mortgage'] = 'Y';
                    } else if (appDataObj.deal_details.mdiObj.insurance_included_in_mortgage === null ||
                        appDataObj.deal_details.mdiObj.insurance_included_in_mortgage === '') {
                        appDataObj.deal_details.mdiObj.insurance_included_in_mortgage = 'Y';
                    }

                    if (formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount')) {
                        let valDefaultInsuranceMortgage = formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').value;
                        if (valDefaultInsuranceMortgage === '') {
                            formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').setValue('Y');
                        } else {
                            formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').setValue(valDefaultInsuranceMortgage);
                        }
                    }

                } else {
                    let val = formGroupObj.get('B1_ProdDet_MortgageDetails_DefaultInsuranceRequired').value;
                    formGroupObj.get('B1_ProdDet_MortgageDetails_DefaultInsuranceRequired').setValue(val);
                    appDataObj.deal_details.mdiObj.default_insurance_required = val;
                    if (formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount')) {
                        let valDefaultInsuranceMortgage = formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').value;
                        formGroupObj.get('B1_ProdDet_MortgageDetails_AddDefaultInsurancetoMortgageAmount').setValue(valDefaultInsuranceMortgage);
                    }

                }
            }


        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onRefreshPropertyDetails ::: Function in  - > form-elementScript-function.ts', e);
        }

    }

    onFundingDateChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onRefreshPropertyDetails ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onRefreshPropertyDetails(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onRefreshPropertyDetails ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onRefreshProductSelectionDetails(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onRefreshProductSelectionDetails ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onTaxPaidbyChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let selectedTaxBy = formGroupObj.value.B1_ProdDet_MortgageProduct_TaxesPaidBy;
            if (formGroupObj.value.B1_ProdDet_MortgageProduct_TaxesPaidBy !== '' && formGroupObj.value.B1_ProdDet_MortgageProduct_TaxesPaidBy !== undefined) {
                let annualTax = appDataObj.property_details.annual_tax;
                let propertytax: number = 0;
                let paymentfrequency = formGroupObj.value.B1_ProdDet_MortgageProduct_PaymentFrequency;
                let itotalFrequencyAmount: any;
                if (selectedTaxBy && selectedTaxBy !== '') {
                    if (paymentfrequency && paymentfrequency !== '' &&
                        appDataObj.property_details.annual_tax && appDataObj.property_details.annual_tax !== '') {

                        ///// logic for mortgage payment frequency dropdown changes on 30Jan2018 STARTS
                        const enumMatchType = this.EnumData['PAYMENT_FREQUENCY'].find(
                            enumData => enumData.keyCode.toString().toLowerCase() === paymentfrequency.toString().toLowerCase());

                        if (enumMatchType && enumMatchType.keyCode) {
                            let iannualTax = appDataObj.property_details.annual_tax;
                            if (enumMatchType.keyCode === '0') { //Monthly
                                propertytax = (parseFloat(iannualTax)) / 12;
                            } else if (enumMatchType.keyCode === '1') { //Semi-monthly
                                propertytax = (parseFloat(iannualTax)) / 24;
                            } else if (enumMatchType.keyCode === '2') { //Bi-weekly
                                propertytax = (parseFloat(iannualTax)) / 26;
                            } else if (enumMatchType.keyCode === '4') { //Weekly
                                propertytax = (parseFloat(iannualTax)) / 52;
                            }
                        }
                    }
                }
                appDataObj.deal_details.mortgageObj.property_tax_component = propertytax.toFixed(2).toString();
                formGroupObj.get('B1_ProdDet_MortgageProduct_PropertyTaxComponent').setValue(propertytax.toFixed(2).toString());

               
                let amountPI = formGroupObj.get('B1_ProdDet_MortgageProduct_PI').value;
                if (amountPI && amountPI !== '') {
                    amountPI = amountPI;
                } else {
                    amountPI = '0';
                }

                let amountCreditorInsurance = appDataObj.deal_details.creditor_insurance_amt;
                if (amountCreditorInsurance && amountCreditorInsurance !== '') {
                    amountCreditorInsurance = amountCreditorInsurance;
                } else {
                    amountCreditorInsurance = '0';
                }

                if (selectedTaxBy && selectedTaxBy !== '' && selectedTaxBy.toString().toLowerCase() === 'cibc') {
                    itotalFrequencyAmount = (propertytax + parseFloat(amountPI.toString()) + parseFloat(amountCreditorInsurance.toString())).toFixed(2);
                } else {
                    itotalFrequencyAmount = (parseFloat(amountPI.toString()) + parseFloat(amountCreditorInsurance.toString())).toFixed(2);
                }

                formGroupObj.get('B1_ProdDet_MortgageProduct_TotalFrequencyPaymentAmount').setValue(itotalFrequencyAmount);


            }
            //appDataObj.deal_details.property_details.annual_tax
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onTaxPaidbyChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    roundToTwo(num: number) {
        return +(Math.round(Number(num + 'e+2')) + 'e-2');
    }



    calculatePLCClientPercent(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let percentagePrime = formGroupObj.get('B1_ProdDet_PLC_Details_Prime').value;
            let spreadAbovePrime = formGroupObj.get('B1_ProdDet_PLC_Details_SpreadOverPrime').value;
            let clientRate = 0;
            percentagePrime = this.eleScriformUliFunObj.getOnlyCurrencyValue(percentagePrime.toString().replace("%", ""), this.lang);
            spreadAbovePrime = this.eleScriformUliFunObj.getOnlyCurrencyValue(spreadAbovePrime.toString().replace("%", ""), this.lang);

            if ((percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') &&
                (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '')) {
                clientRate = (parseFloat(percentagePrime) + parseFloat(spreadAbovePrime));
            } else if (percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') {
                clientRate = parseFloat(percentagePrime);
            } else if (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '') {
                clientRate = parseFloat(spreadAbovePrime);
            } else {
                clientRate = 0;
            }

            if (clientRate && clientRate.toString() !== '') {
                formGroupObj.get('B1_ProdDet_PLC_Details_ClientRate').setValue((clientRate.toFixed(2)).toString());

            } else {
                formGroupObj.get('B1_ProdDet_PLC_Details_ClientRate').setValue('0');
            }
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onTaxPaidbyChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }
    calculatePLCClientPercentForWizard(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let percentagePrime = formGroupObj.get('Wizard_PLC_Details_Prime').value;
            let spreadAbovePrime = formGroupObj.get('Wizard_PLC_Details_SpreadAbovePrime').value;
            let clientRate = 0;

            percentagePrime = percentagePrime.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            spreadAbovePrime = spreadAbovePrime.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

            if ((percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') &&
                (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '')) {
                clientRate = (parseFloat(percentagePrime) + parseFloat(spreadAbovePrime));
            } else if (percentagePrime && percentagePrime.toString().length > 0 && percentagePrime.toString() !== '') {
                clientRate = parseFloat(percentagePrime);
            } else if (spreadAbovePrime && spreadAbovePrime.toString().length > 0 && spreadAbovePrime.toString() !== '') {
                clientRate = parseFloat(spreadAbovePrime);
            } else {
                clientRate = 0;
            }

            if (clientRate && clientRate.toString() !== '') {
                formGroupObj.get('Wizard_PLC_Details_ClientRate').setValue((clientRate.toFixed(2)).toString());

            } else {
                formGroupObj.get('Wizard_PLC_Details_ClientRate').setValue('0');
            }
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > calculatePLCClientPercentForWizard ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    changeMortgageInsurancePremiumAmount(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let requestedAmount = appDataObj.transaction_details.deal_amount;
            let mortgageInsurancePremiumAmount: any = '';
            let mortgageInsurancePremium = formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsurancePremium').value;
            requestedAmount = requestedAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
            if (requestedAmount && requestedAmount.toString().length > 0) {
                requestedAmount = requestedAmount;
            }
            else {
                requestedAmount = 0;
            }
            if (requestedAmount && requestedAmount.toString().length > 0) {
                if (mortgageInsurancePremium && mortgageInsurancePremium.toString().length > 0 && mortgageInsurancePremium.toString() !== '0') {
                    mortgageInsurancePremiumAmount = ((parseFloat(requestedAmount) * parseFloat(mortgageInsurancePremium)) / 100);
                    mortgageInsurancePremiumAmount = (mortgageInsurancePremiumAmount !== NaN ? mortgageInsurancePremiumAmount : '0');
                }
                else {
                    mortgageInsurancePremiumAmount = 0;
                }
            }
            if (mortgageInsurancePremium) {
                if (mortgageInsurancePremium > 0) {
                    formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsurancePremiumAmount').setValue((mortgageInsurancePremiumAmount).toFixed(2).toString());
                    let totalMortgageAmount = (parseFloat(requestedAmount) + parseFloat(mortgageInsurancePremiumAmount)).toFixed(2).toString();
                    formGroupObj.get('B1_ProdDet_MortgageDetails_TotalMortgageAmount').setValue((totalMortgageAmount).toString());
                } else {
                    mortgageInsurancePremium = 0;
                    formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsurancePremiumAmount').setValue((mortgageInsurancePremiumAmount).toFixed(2).toString());
                    let totalMortgageAmount = (parseFloat(requestedAmount) + parseFloat(mortgageInsurancePremiumAmount)).toFixed(2).toString();
                    formGroupObj.get('B1_ProdDet_MortgageDetails_TotalMortgageAmount').setValue((totalMortgageAmount).toString());
                }
                //B1_ProdDet_MortgageDetails_TotalMortgageAmount
            } else {
               if (mortgageInsurancePremium > 0) {
                    formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsurancePremiumAmount').setValue((mortgageInsurancePremiumAmount).toFixed(2).toString());
                    let totalMortgageAmount = (parseFloat(requestedAmount) + parseFloat(mortgageInsurancePremiumAmount)).toFixed(2).toString();
                    formGroupObj.get('B1_ProdDet_MortgageDetails_TotalMortgageAmount').setValue((totalMortgageAmount).toString());
                } else {
                    mortgageInsurancePremium = 0;
                    formGroupObj.get('B1_ProdDet_MortgageDetails_MortgageInsurancePremiumAmount').setValue((mortgageInsurancePremiumAmount).toFixed(2).toString());
                    let totalMortgageAmount = (parseFloat(requestedAmount) + parseFloat(mortgageInsurancePremiumAmount)).toFixed(2).toString();
                    formGroupObj.get('B1_ProdDet_MortgageDetails_TotalMortgageAmount').setValue((totalMortgageAmount).toString());
                }
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeLiability ::: Function in  - > form-elementScript-function.ts', e)
        }
    }


    onTrailZeroAppend(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let numberTrail: any;
            let fieldMaxlength: any;
            let trailZeroLength: number;
            let fldObj = formGroupObj.get(buildObj.formGroup_key);
            let fldMax = Number(buildObj.formGroup_valid_max);
            if (fldObj && fldObj.valid) {
                let vlueStr: string = fldObj.value
                if (vlueStr && vlueStr.length > 0 && vlueStr.length < fldMax) {
                    let appedZEROS = Array(Math.max((fldMax - vlueStr.length + 1), 0)).join('0').toString();
                    let finalStri = appedZEROS + vlueStr
                    fldObj.setValue(finalStri);
                }
            }

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onProductInterestDiscountChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    onThirdPartyOccupationDataChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = [];
            this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = [];
            const occupation_category = appDataObj.third_party_application.occupation_category;
            const occupation_description = appDataObj.third_party_application.occupation_description;
            const occupation_types = this.occupation_data.occupationDetails.find(occupation => occupation.category.toString().toLowerCase() === occupation_category.toString().toLowerCase());
            const tempOccupationTypeDesc = [];
            const tempOccupationTypeSubDesc = [];
            if (occupation_types) {
                occupation_types.occupation.forEach(occupation => {
                    const enumMatchType = this.EnumData['OCCUPATION_TYPE_DESCRIPTION'].find(
                        enumData => enumData.keyCode.toString().toLowerCase() === occupation.occupationCode.toString().toLowerCase());
                    if (occupation_description && occupation_description.toString().toLowerCase() === occupation.occupationCode.toLowerCase()) {
                        occupation.subTypes.forEach(subType => {
                            const enumMatchSubType = this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION'].find(
                                enumData => enumData.keyCode.toString().toLowerCase() === subType.toString().toLowerCase());
                            tempOccupationTypeSubDesc.push(enumMatchSubType);
                        });
                        this.EnumData['OCCUPATION_TYPE_SUB_DESCRIPTION_1'] = tempOccupationTypeSubDesc;
                    }
                    tempOccupationTypeDesc.push(enumMatchType);
                });
                this.EnumData['OCCUPATION_TYPE_DESCRIPTION_1'] = tempOccupationTypeDesc;
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onThirdPartyOccupationDataChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }


    onThirdParty_CountryChange1(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            appDataObj.third_party_application.street_number = '';
            appDataObj.third_party_application.street_name = '';
            appDataObj.third_party_application.City = '';
            appDataObj.third_party_application.Direction = '';
            appDataObj.third_party_application.Province = '';
            appDataObj.third_party_application.Postal_Code = '';
            if (evt.target.value === '') {
                formGroupObj.get(evt.target.id).setValue("146")
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onMailing_Asset_CountryChange ::: Function in  - > form-elementScript-function.ts', e)

        }
    }

    onThirdParty_CountryChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
            appDataObj.third_party_application.direction = "";
            appDataObj.third_party_application.state = "";
            appDataObj.third_party_application.zip = "";
            appDataObj.third_party_application.province = "";
            appDataObj.third_party_application.city = "";
            appDataObj.third_party_application.street_number = '';
            appDataObj.third_party_application.street_name = '';
            appDataObj.third_party_application.postal_code = '';
            this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onThirdParty_CountryChange ::: Function in  - > form-elementScript-function.ts', e)

        }

    }


    setHPPLimit(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        let requestedMortgageAmount = appDataObj.transaction_details.deal_amount;
        let requestedPLCAmount = appDataObj.deal_details.plc.plc_requested_Limit;
        let hppLimit = 0;

        requestedMortgageAmount = requestedMortgageAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");
        requestedPLCAmount = requestedPLCAmount.toString().replace(",", "").replace("$", "").replace(" ", "").replace("%", "");

        if ((requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') &&
            (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '')) {
            hppLimit = (parseFloat(requestedMortgageAmount) + parseFloat(requestedPLCAmount));
        } else if (requestedMortgageAmount && requestedMortgageAmount.toString().length > 0 && requestedMortgageAmount.toString() !== '') {
            hppLimit = parseFloat(requestedMortgageAmount);
        } else if (requestedPLCAmount && requestedPLCAmount.toString().length > 0 && requestedPLCAmount.toString() !== '') {
            hppLimit = parseFloat(requestedPLCAmount);
        } else {
            hppLimit = 0;
        }

        if (hppLimit && hppLimit.toString() !== '') {
            formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').setValue((hppLimit.toFixed(2)).toString());
        } else {
            formGroupObj.get('B1_ProdDet_HPP_subsection_HPPLimit').setValue('0');
        }

        let chargeAmountOption = appDataObj.deal_details.plc.collateral_charge;
        let chargeAmount = appDataObj.deal_details.plc.hppSectionDetails.charge_amount
        let getModel = appDataObj.deal_details;

        if (chargeAmountOption) {
            if (chargeAmountOption === '1') {
                if (getModel.purchase_price && getModel.purchase_price !== '') {
                    appDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.purchase_price.toString();
                } else if (getModel.estimated_value && getModel.estimated_value !== '') {
                    appDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.estimated_value.toString();
                } else if (getModel.appraised_value && getModel.appraised_value !== '') {
                    appDataObj.deal_details.plc.hppSectionDetails.charge_amount = getModel.appraised_value.toString();
                } else {
                    appDataObj.deal_details.plc.hppSectionDetails.charge_amount = '0';
                }
            }
            if (chargeAmountOption === '2') {
                if (hppLimit && hppLimit.toString() !== '') {
                    formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue((hppLimit.toFixed(2)).toString());
                }
                else {
                    formGroupObj.get('B1_ProdDet_HPP_subsection_ChargeAmount').setValue('0');
                }
            }
        }

    }

    changeHPPLimit(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            this.parentObj.refreshOnDemand(formGroupObj);
            this.parentObj.onViewRefresh();
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeLiability ::: Function in  - > form-elementScript-function.ts', e)
        }
    }

    onRequestInterestRateChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {

        formGroupObj.controls.B1_ProdDet_CrossSellProduct_UPLC_RequestInterestAdjustment.setValue(Number(formGroupObj.controls.B1_ProdDet_CrossSellProduct_UPLC_RequestInterestAdjustment.value).toFixed(2));
       
    }

    assignPropertyName(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        appDataObj.select_property_name = evt.target.options[evt.target.selectedIndex].innerHTML;
    }

    assignRefinanceDetails(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let iLiabilities = formGroupObj.get('B1_ProdDet_Refinance_Details_AssociatedLiabilities').value;
            if (formGroupObj.get('B1_ProdDet_Refinance_Details_AssociatedLiabilities')) {
                if (iLiabilities && iLiabilities !== 'undefined') {
                    formGroupObj.get('B1_ProdDet_Refinance_Details_AssociatedLiabilities').setValue(iLiabilities);
                    appDataObj.property_details.refinances.associated_liabilities = iLiabilities;
                } else {
                    appDataObj.property_details.refinances.associated_liabilities = '';
                }
            }
            let selectedValuesplit = iLiabilities.split('#');
            let selectedLiabilities;

            if (selectedValuesplit[1] === 'CVD') {
                selectedLiabilities = appDataObj.applicants[0].borrowers[0].liabilities.find(
                    liab => (liab.select_property === selectedValuesplit[0] &&
                        liab.Liability_Source === selectedValuesplit[1] &&
                        liab.id === selectedValuesplit[2])
                )
            } else {
                selectedLiabilities = appDataObj.applicants[0].borrowers[0].liabilities.find(
                    liab => (liab.select_property === selectedValuesplit[0] &&
                        liab.Liability_Source === selectedValuesplit[1] &&
                        liab.liability_number === selectedValuesplit[2]))
            }
           
            let selectedSubjectPropValue = formGroupObj.get('B1_ProdDet_Refinance_Details_AssociatedLiabilities').value;

            if (selectedLiabilities && (selectedSubjectPropValue.toString() !== '' && selectedSubjectPropValue.toString() !== '-1')) {
                if (appDataObj.property_details.refinances.maturity_date !== undefined) {
                    if (selectedLiabilities.maturity_date) {
                        appDataObj.property_details.refinances.maturity_date = selectedLiabilities.maturity_date;
                    } else {
                        appDataObj.property_details.refinances.maturity_date = '';
                    }
                }

                if (appDataObj.property_details.refinances.existing_mortgage_accNumber !== undefined) {
                    if (selectedLiabilities.existing_mortgage_accNumber) {
                        appDataObj.property_details.refinances.existing_mortgage_accNumber = selectedLiabilities.existing_mortgage_accNumber;
                    } else {
                        appDataObj.property_details.refinances.existing_mortgage_accNumber = '';
                    }
                }


                if (appDataObj.property_details.refinances.loan_type !== undefined) {
                    if (selectedLiabilities.Liability_Type) {
                        appDataObj.property_details.refinances.loan_type = selectedLiabilities.Liability_Type;
                    } else {
                        appDataObj.property_details.refinances.loan_type = '';
                    }
                }

                if (appDataObj.property_details.refinances.previous_insurer_number !== undefined) {
                    if (selectedLiabilities.insurer_number) {
                        appDataObj.property_details.refinances.previous_insurer_number = selectedLiabilities.insurer_number;
                    } else {
                        appDataObj.property_details.refinances.previous_insurer_number = '';
                    }
                }

                if (appDataObj.property_details.refinances.existing_mortgage_balance !== undefined) {
                    if (selectedLiabilities.balance) {
                        appDataObj.property_details.refinances.existing_mortgage_balance = selectedLiabilities.balance;
                        if (appDataObj.mortgage_details && appDataObj.mortgage_details.outstanding_mortgage_amount !== undefined) {
                            appDataObj.mortgage_details.outstanding_mortgage_amount = selectedLiabilities.balance;

                        }
                    } else {
                        appDataObj.property_details.refinances.existing_mortgage_balance = '';
                    }
                }

                if (appDataObj.property_details.refinances.rank_of_charge !== undefined) {
                    if (selectedLiabilities.rank_of_charge) {
                        appDataObj.property_details.refinances.rank_of_charge = selectedLiabilities.rank_of_charge;
                    } else {
                        appDataObj.property_details.refinances.rank_of_charge = '1';
                    }
                }

                if (appDataObj.property_details.refinances.existing_liability_fi !== undefined) {
                    if (selectedLiabilities.Creditor_Name) {
                        if (selectedLiabilities.Creditor_Name === 'CIBC') {
                            appDataObj.property_details.refinances.existing_liability_fi = '87';
                        } else {
                            appDataObj.property_details.refinances.existing_liability_fi = selectedLiabilities.Creditor_Name;
                        }
                    } else {
                        appDataObj.property_details.refinances.existing_liability_fi = '';
                    }
                }

                if (appDataObj.property_details.refinances.monthly_pi !== undefined) {
                    if (selectedLiabilities.payment) {
                        appDataObj.property_details.refinances.monthly_pi = selectedLiabilities.payment;
                    } else {
                        appDataObj.property_details.refinances.monthly_pi = '';
                    }
                }

                if (appDataObj.property_details.refinances.pay_out !== undefined) {
                    if (selectedLiabilities.Pay_Out) {
                        appDataObj.property_details.refinances.pay_out = selectedLiabilities.Pay_Out;
                    } else {
                        appDataObj.property_details.refinances.pay_out = '';
                    }
                }
            }
            else {
                appDataObj.property_details.refinances.associated_liabilities = '';
                appDataObj.property_details.refinances.maturity_date = '';
                appDataObj.property_details.refinances.existing_mortgage_accNumber = '';
                appDataObj.property_details.refinances.loan_type = '';
                appDataObj.property_details.refinances.previous_insurer_number = '';
                appDataObj.property_details.refinances.existing_mortgage_balance = '';
            }
            this.parentObj.onViewRefresh();
            this.parentObj.refreshOnDemand(formGroupObj);

        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onTaxPaidbyChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

    formatDatetoAPI(formatDate: any) {
        let dateStr = '';
        dateStr = formatDate.getFullYear() + '-' + (formatDate.getMonth() + 1) + '-' + formatDate.getDate();
        return dateStr;
    }


    onBuilderRateCapPeriodChange(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            let isBuildRateCap = formGroupObj.value.B1_ProdDet_MortgageProduct_BuilderRateCap;
            if (formGroupObj.value.B1_ProdDet_MortgageProduct_BuilderRateCap !== '' && formGroupObj.value.B1_ProdDet_MortgageProduct_BuilderRateCap !== undefined) {
                let annualTax = appDataObj.property_details.annual_tax;
                let builderCapExpiryDate: any;
                let builderCapPeriod = formGroupObj.value.B1_ProdDet_MortgageProduct_BuilderRateCapPeriod;
                let currentDate: Date = new Date();
                let itotalFrequencyAmount: any;
                if (isBuildRateCap && isBuildRateCap !== '') {
                    if (builderCapPeriod && builderCapPeriod !== '') {
                        const enumMatchType = this.EnumData['RATECAP_PERIOD'].find(
                            enumData => enumData.keyCode.toString().toLowerCase() === builderCapPeriod.toString().toLowerCase());
                        let assignBuildRateExpiryDate: any;// = new Date(currentDate.setMonth(24));
                        if (enumMatchType && enumMatchType.keyCode) {
                            let iannualTax = appDataObj.property_details.annual_tax;
                            if (enumMatchType.keyCode === '0') { //6 months
                                assignBuildRateExpiryDate = new Date(currentDate.setMonth((currentDate.getMonth() + 6)));
                            }
                            else if (enumMatchType.keyCode === '1') { //9 months
                                assignBuildRateExpiryDate = new Date(currentDate.setMonth((currentDate.getMonth() + 9)));
                            }
                            else if (enumMatchType.keyCode === '2') { //12 months
                                assignBuildRateExpiryDate = new Date(currentDate.setMonth((currentDate.getMonth() + 12)));
                            }
                            else if (enumMatchType.keyCode === '3') { //18 months
                                assignBuildRateExpiryDate = new Date(currentDate.setMonth((currentDate.getMonth() + 18)));
                            }
                            else if (enumMatchType.keyCode === '4') { //24 months
                                assignBuildRateExpiryDate = new Date(currentDate.setMonth((currentDate.getMonth() + 24)));
                            }
                            //builderCapExpiryDate = assignBuildRateExpiryDate;
                            //builderCapExpiryDate = '2019-01-26';
                            builderCapExpiryDate = this.formatDatetoAPI(assignBuildRateExpiryDate);
                        }
                    }
                }
                appDataObj.deal_details.mortgageObj.mortgage_builder_rate_cap_expiry = builderCapExpiryDate.toString();
                formGroupObj.get('B1_ProdDet_MortgageProduct_BuilderRateCapExpiryDate').setValue(builderCapExpiryDate.toString());

            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > onBuilderRateCapPeriodChange ::: Function in  - > form-elementScript-function.ts', e);
        }
    }


    onChangeSPProvinceType(evt: any, buildObj: IformGroupObject, formGroupObj: FormGroup, appDataObj: any) {
        try {
            if (evt.target.value.toString() !== 'BC') {
                appDataObj.property_details.bc_tax_grant = '1';
                formGroupObj.get('B1_Property_Details_BCTaxGrant').setValue('1');
            } else {
                appDataObj.property_details.bc_tax_grant = '';
                formGroupObj.get('B1_Property_Details_BCTaxGrant').setValue('');
            }
            this.parentObj.refreshOnDemand(formGroupObj);
        } catch (e) {
            this.eleScriformUliFunObj.displayErrorInConsole('Error - > ChangeDwelling Type ::: Function in  - > form-elementScript-function.ts', e);
        }
    }

}
